/* Massimo Collection Card Render — koleksiyon kartlarında ürün sayfasındaki Massimo
 * preview motoruyla aynı giydirme render'ını + RASTGELE bordür gösterir.
 * Click ile product page'e bordür ID URL param geçer.
 *
 * Veri kaynağı: massimo-ozel-olcu-config.js (browser cache'ten gelirse anlık, yoksa fetch).
 * Cache: sessionStorage[massimoCardBorder:<handle>] — sayfa refresh'lerinde aynı border kalır.
 *
 * No silent fallback: preview kaynakları yoksa kart dokunulmaz (Shopify original kalır),
 * border fabric yoksa hata loglanır.
 */
(function () {
  'use strict';
  if (window.__MASSIMO_COLLECTION_RENDER__) return;
  window.__MASSIMO_COLLECTION_RENDER__ = true;

  var BUILD = 'massimo-collection-render-v25-product-preview-eu-badge-cards';
  // v12: Shopify handle quality ↔ config quality key alias
  //  - Shopify handle: "barcelona", "kordoba" gibi müşteri-yüzlü adlar
  //  - Config key: "barceleno", "cordoba" gibi Massimo iç kalite kodları
  // Alias bulunamazsa direkt handle quality ile devam edilir.
  var QUALITY_ALIAS = {
    'barcelona': 'barceleno'
  };
  var CARD_W = 1200;
  var CARD_H = Math.round(1200 * (230 / 160)); // 1725 → 160x230 oranı
  var BORDER_DEPTH_PX = 55;
  // Pattern tile: kaç kez yatayda tekrarlasın. Halı 160 cm, sample image ~30 cm → ~5 tile
  var PATTERN_TILES_HORIZONTAL = 5;
  var IMG_LOAD_TIMEOUT = 20000;
  var CONFIG_TIMEOUT = 8000;
  var PREVIEW_ENGINE_TIMEOUT = 15000;

  var configPromise = null;
  var previewEnginePromise = null;
  var renderQueue = [];
  var imageCache = {};
  var averageColorCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function loadImage(src, opts) {
    opts = opts || {};
    if (imageCache[src]) return imageCache[src];
    var p = new Promise(function (resolve, reject) {
      var img = new Image();
      if (opts.crossOrigin !== false && /^https?:\/\//.test(src)) img.crossOrigin = 'anonymous';
      var done = false;
      var to = setTimeout(function () { fail(new Error('image timeout: ' + src)); }, IMG_LOAD_TIMEOUT);
      function cleanup() {
        clearTimeout(to);
        img.onload = null;
        img.onerror = null;
      }
      function fail(err) {
        if (done) return;
        done = true;
        cleanup();
        delete imageCache[src];
        reject(err);
      }
      img.onload = function () {
        if (done) return;
        done = true;
        cleanup();
        resolve(img);
      };
      img.onerror = function () { fail(new Error('image error: ' + src)); };
      img.src = src;
    });
    imageCache[src] = p;
    return p;
  }

  function loadConfig() {
    if (configPromise) return configPromise;
    // Önce in-memory check
    if (window.__MASSIMO_ALL_CONFIGS__) {
      configPromise = Promise.resolve(window.__MASSIMO_ALL_CONFIGS__);
      return configPromise;
    }
    // Yoksa config dosyasını fetch et — Shopify CDN'den (asset URL'ini script tag'lerinden bul)
    var src = '';
    var existingTag = document.querySelector('script[src*="massimo-ozel-olcu-config"]');
    if (existingTag) src = existingTag.src;
    if (!src) {
      // Theme asset URL pattern: /cdn/shop/t/XX/assets/massimo-ozel-olcu-config.js
      var anyAsset = document.querySelector('script[src*="/cdn/shop/t/"][src*="assets/"]');
      if (anyAsset) src = anyAsset.src.replace(/assets\/[^?]+/, 'assets/massimo-ozel-olcu-config.js');
    }
    if (!src) {
      configPromise = Promise.reject(new Error('config URL bulunamadı'));
      return configPromise;
    }
    configPromise = new Promise(function (resolve, reject) {
      var to = setTimeout(function () { reject(new Error('config fetch timeout')); }, CONFIG_TIMEOUT);
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () {
        clearTimeout(to);
        if (window.__MASSIMO_ALL_CONFIGS__) resolve(window.__MASSIMO_ALL_CONFIGS__);
        else reject(new Error('config script loaded but no __MASSIMO_ALL_CONFIGS__'));
      };
      s.onerror = function () { clearTimeout(to); reject(new Error('config script error')); };
      document.head.appendChild(s);
    });
    return configPromise;
  }

  function assetUrlFor(assetName) {
    var script = document.querySelector('script[src*="' + assetName + '"]');
    if (script && script.src) return script.src;

    var anchors = [
      document.querySelector('script[src*="massimo-ozel-olcu-config"]'),
      document.querySelector('script[src*="massimo-collection-render"]'),
      document.querySelector('script[src*="/cdn/shop/t/"][src*="assets/"]')
    ];
    for (var i = 0; i < anchors.length; i++) {
      var src = anchors[i] && anchors[i].src;
      if (!src) continue;
      var base = src.split('?')[0];
      if (base.indexOf('/assets/') > -1) {
        return base.replace(/assets\/[^/]+$/, 'assets/' + assetName) + '?massimo_collection_engine=' + encodeURIComponent(BUILD);
      }
    }
    return '';
  }

  function loadPreviewEngine() {
    if (window.MassimoOzelOlcuPreview) return Promise.resolve(window.MassimoOzelOlcuPreview);
    if (previewEnginePromise) return previewEnginePromise;

    var src = assetUrlFor('massimo-ozel-olcu-preview.min.js');
    if (!src) {
      previewEnginePromise = Promise.reject(new Error('preview engine URL bulunamadı'));
      return previewEnginePromise;
    }

    previewEnginePromise = new Promise(function (resolve, reject) {
      var to = setTimeout(function () { reject(new Error('preview engine timeout')); }, PREVIEW_ENGINE_TIMEOUT);
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () {
        clearTimeout(to);
        if (window.MassimoOzelOlcuPreview) resolve(window.MassimoOzelOlcuPreview);
        else reject(new Error('preview engine loaded but no MassimoOzelOlcuPreview'));
      };
      s.onerror = function () { clearTimeout(to); reject(new Error('preview engine script error')); };
      document.head.appendChild(s);
    });
    return previewEnginePromise;
  }

  function optionValue(value, fallback) {
    return value === undefined || value === null || value === '' ? fallback : value;
  }

  function pickPreviewBaseImage(productCfg) {
    var images = Array.isArray(productCfg && productCfg.productImages) ? productCfg.productImages.filter(Boolean) : [];
    return images[0] || (productCfg && (productCfg.previewBaseImage || productCfg.sourceImage)) || '';
  }

  function pickPatternImage(productCfg) {
    var images = Array.isArray(productCfg && productCfg.productImages) ? productCfg.productImages.filter(Boolean) : [];
    return images[1] || (productCfg && productCfg.patternImage) || '';
  }

  function pickRenderPatternImage(productCfg) {
    var params = (productCfg && productCfg.previewParams) || {};
    return params.singleSurfaceImage || (productCfg && productCfg.singleSurfaceImage) || pickPatternImage(productCfg);
  }

  function buildPreviewOptions(productCfg, canvas) {
    var previewParams = Object.assign({}, (productCfg && productCfg.previewParams) || {});
    var out = Object.assign({}, previewParams, {
      canvas: canvas,
      sourceImage: pickPreviewBaseImage(productCfg),
      patternImage: pickRenderPatternImage(productCfg),
      edgeType: 'bordur',
      shape: {
        type: 'dikdortgen',
        widthCm: 160,
        lengthCm: 230
      },
      bgThreshold: optionValue(optionValue(previewParams.bgBrightness, previewParams.bgThreshold), productCfg && productCfg.bgThreshold),
      biyeDepthPct: optionValue(previewParams.biyeDepthPct, productCfg && productCfg.biyeDepthPct),
      bordurDepthPct: optionValue(previewParams.bordurDepthPct, productCfg && productCfg.bordurDepthPct),
      maxCanvasWidth: Math.max(CARD_W, optionValue(previewParams.maxCanvasWidth, productCfg && productCfg.maxCanvasWidth) || CARD_W),
      maxCanvasHeight: Math.max(CARD_H, optionValue(previewParams.maxCanvasHeight, productCfg && productCfg.maxCanvasHeight) || CARD_H),
      allowCanvasUpscale: optionValue(previewParams.allowCanvasUpscale, productCfg && productCfg.allowCanvasUpscale)
    });
    return out;
  }

  function renderProductPreviewCanvas(productCfg, border) {
    return loadPreviewEngine().then(function () {
      var source = pickPreviewBaseImage(productCfg);
      var pattern = pickRenderPatternImage(productCfg);
      if (!source || !pattern) throw new Error('preview source / pattern yok');
      var canvas = document.createElement('canvas');
      var preview = new window.MassimoOzelOlcuPreview(buildPreviewOptions(productCfg, canvas));
      return preview.setEdgeAndFabric('bordur', border).then(function () {
        return canvas;
      });
    });
  }

  function drawStar5(cx, cy, r) {
    var pts = [];
    for (var i = 0; i < 10; i++) {
      var a = (i * 36 - 90) * Math.PI / 180;
      var rr = i % 2 === 0 ? r : r * 0.382;
      pts.push((cx + rr * Math.cos(a)).toFixed(2) + ',' + (cy + rr * Math.sin(a)).toFixed(2));
    }
    return '<polygon points="' + pts.join(' ') + '"/>';
  }

  function generate12EuStars() {
    var parts = [];
    for (var i = 0; i < 12; i++) {
      var angle = (i * 30 - 90) * Math.PI / 180;
      parts.push(drawStar5(50 + 32 * Math.cos(angle), 50 + 32 * Math.sin(angle), 4.2));
    }
    return parts.join('');
  }

  function ensureCardBadgeStyles() {
    if (document.getElementById('massimo-collection-render-styles')) return;
    var css = ''
      + '.massimo-card-eu-badge-host{position:relative!important}'
      + '.massimo-card-eu-badge{position:absolute!important;inset:auto 8px 8px auto!important;left:auto!important;top:auto!important;width:auto!important;height:auto!important;min-width:0!important;min-height:0!important;max-width:calc(100% - 16px)!important;display:inline-flex!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important;padding:5px 9px 5px 6px!important;background:linear-gradient(135deg,rgba(251,248,241,.95),rgba(246,242,235,.95))!important;border:1px solid #9a6838!important;border-radius:8px!important;box-shadow:0 1px 3px rgba(143,95,52,.14),0 0 0 3px rgba(143,95,52,.05)!important;z-index:6!important;pointer-events:none!important;user-select:none!important;white-space:nowrap!important;transform:none!important;opacity:1!important}'
      + '.massimo-card-eu-badge__icon{width:22px!important;height:22px!important;flex:0 0 auto!important;display:block!important;filter:drop-shadow(0 1px 2px rgba(0,51,153,.22))}'
      + '.massimo-card-eu-badge__title{font-weight:700!important;font-size:10px!important;line-height:1!important;letter-spacing:.7px!important;text-transform:uppercase!important;color:#3a2812!important}'
      + '@media(max-width:768px){.massimo-card-eu-badge{inset:auto 6px 6px auto!important;padding:4px 7px 4px 5px!important;gap:5px!important}.massimo-card-eu-badge__icon{width:18px!important;height:18px!important}.massimo-card-eu-badge__title{font-size:9px!important;letter-spacing:.5px!important}}';
    var style = document.createElement('style');
    style.id = 'massimo-collection-render-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function ensureEuBadge(cardRoot, preferredHost) {
    if (!cardRoot || cardRoot.querySelector('.massimo-card-eu-badge')) return;
    ensureCardBadgeStyles();
    var host = preferredHost
      || (cardRoot.querySelector('img[data-massimo-card-render]') && cardRoot.querySelector('img[data-massimo-card-render]').parentElement)
      || cardRoot;
    if (!host || !host.appendChild) return;
    host.classList.add('massimo-card-eu-badge-host');
    var badge = document.createElement('div');
    badge.className = 'massimo-card-eu-badge';
    badge.setAttribute('aria-label', 'Made in Europe');
    badge.title = 'Made in Europe';
    badge.innerHTML =
      '<svg class="massimo-card-eu-badge__icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle cx="50" cy="50" r="48" fill="#003399"/>' +
      '<g fill="#FFCC00">' + generate12EuStars() + '</g>' +
      '</svg>' +
      '<span class="massimo-card-eu-badge__title">Made in Europe</span>';
    host.appendChild(badge);
  }

  function parseHandle(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function findCardRoot(link) {
    var node = link;
    for (var i = 0; i < 6 && node; i++) {
      node = node.parentElement;
      if (!node) return null;
      // Card wrapper'ı bul — img barındıran yakın container
      if (node.querySelector && node.querySelector('img') && node.querySelectorAll('a[href*="/products/"]').length > 0) {
        return node;
      }
    }
    return null;
  }

  function findCardImage(cardRoot) {
    // v9: bütün img'leri döndür (main + hover) — hover varyantı tema render-ediyor
    var imgs = cardRoot.querySelectorAll('img');
    if (!imgs.length) return null;
    return Array.prototype.slice.call(imgs);
  }

  function matchesConfiguredHandle(productCfg, handle) {
    if (!productCfg || !handle) return false;
    if (productCfg.productHandle === handle || productCfg.shopifyHandle === handle) return true;
    var handles = productCfg.shopifyHandles || {};
    for (var edgeType in handles) {
      if (Object.prototype.hasOwnProperty.call(handles, edgeType) && handles[edgeType] === handle) return true;
    }
    return false;
  }

  function findProductConfigByHandle(config, handle) {
    var products = (config && config.products) || {};
    for (var key in products) {
      if (Object.prototype.hasOwnProperty.call(products, key) && matchesConfiguredHandle(products[key], handle)) {
        return products[key];
      }
    }
    return null;
  }

  // v5: SPREAD COLORS — sadece parlak/belirgin renkler, sıralı assign. İlk 4 kart kesin
  // farklı parlak renk alır. Session başına rastgele offset → her sayfa açılışında farklı.
  var SPREAD_BORDER_IDS = [
    'canvas-49', // turuncu/rust
    'canvas-33', // bordo/kırmızı
    'canvas-47', // koyu lacivert
    'canvas-48', // zeytin yeşili
    'canvas-84', // koyu kahve
    'canvas-14', // mavi
    'canvas-02', // siyah
    'canvas-26'  // gri-mavi
  ];
  var pageCardIndex = 0;
  var SESSION_OFFSET = (function () {
    try {
      var saved = sessionStorage.getItem('massimoCardSpreadOffset:v5');
      if (saved !== null) return parseInt(saved, 10) || 0;
    } catch (_) {}
    var rnd = Math.floor(Math.random() * SPREAD_BORDER_IDS.length);
    try { sessionStorage.setItem('massimoCardSpreadOffset:v5', String(rnd)); } catch (_) {}
    return rnd;
  })();

  function pickRandomBorder(handle, canvasFabrics) {
    var storageKey = 'massimoCardBorder:v5:' + handle;
    var cached = null;
    try { cached = sessionStorage.getItem(storageKey); } catch (_) {}
    if (cached) {
      for (var i = 0; i < canvasFabrics.length; i++) {
        if (canvasFabrics[i].id === cached) return canvasFabrics[i];
      }
    }
    // Sıralı seçim — pageCardIndex SPREAD_BORDER_IDS üzerinde cycle eder
    var available = [];
    for (var s = 0; s < SPREAD_BORDER_IDS.length; s++) {
      for (var c = 0; c < canvasFabrics.length; c++) {
        if (canvasFabrics[c].id === SPREAD_BORDER_IDS[s]) { available.push(canvasFabrics[c]); break; }
      }
    }
    if (!available.length) available = canvasFabrics.slice();
    var idx = (SESSION_OFFSET + pageCardIndex) % available.length;
    pageCardIndex++;
    var picked = available[idx];
    try { sessionStorage.setItem(storageKey, picked.id); } catch (_) {}
    return picked;
  }

  // v2: Fabric'in CENTER bölgesini sample edip uniform weave preserve eder.
  // Önceki versiyon `createPattern(fabricImg, 'repeat')` ile fabric'in (0,0) köşesinden
  // başlıyordu — bu sürekli aynı flat bölge görünüyordu, weave detay kayboluyordu.
  var fabricTileCache = {};
  function getFabricTile(ctx, fabricImg, tileSize) {
    var key = (fabricImg.src || fabricImg.currentSrc || '') + '|' + tileSize;
    if (fabricTileCache[key]) return fabricTileCache[key];
    var iw = fabricImg.naturalWidth || fabricImg.width || tileSize;
    var ih = fabricImg.naturalHeight || fabricImg.height || tileSize;
    var cropSize = Math.floor(Math.min(iw, ih) * 0.45); // %45 center crop
    var cropX = Math.floor((iw - cropSize) / 2);
    var cropY = Math.floor((ih - cropSize) / 2);
    var tile = document.createElement('canvas');
    tile.width = tileSize;
    tile.height = tileSize;
    var tctx = tile.getContext('2d');
    tctx.imageSmoothingEnabled = true;
    tctx.imageSmoothingQuality = 'high';
    tctx.drawImage(fabricImg, cropX, cropY, cropSize, cropSize, 0, 0, tileSize, tileSize);
    var pattern = ctx.createPattern(tile, 'repeat');
    fabricTileCache[key] = pattern;
    return pattern;
  }

  function drawFabricBorderStrip(ctx, x, y, w, h, fabricImg) {
    // v3: tile size BORDER_DEPTH'e yakın → weave detay her tile'da gözükür, flat görünüm yok
    var tileSize = Math.max(60, Math.floor(BORDER_DEPTH_PX * 1.4)); // ~78px tile for 56 border
    var pattern = getFabricTile(ctx, fabricImg, tileSize);
    ctx.save();
    ctx.fillStyle = pattern;
    ctx.fillRect(x, y, w, h);
    ctx.restore();
  }

  function drawSingleSurfaceBody(ctx, surfaceImg, x, y, w, h, insetPct) {
    var iw = surfaceImg.naturalWidth || surfaceImg.width;
    var ih = surfaceImg.naturalHeight || surfaceImg.height;
    var scale = Math.max(w / iw, h / ih);
    var sw = w / scale;
    var sh = h / scale;
    var sx = Math.max(0, (iw - sw) / 2);
    var sy = Math.max(0, (ih - sh) / 2);
    if (insetPct) {
      var insetX = sw * insetPct;
      var insetY = sh * insetPct;
      sx += insetX;
      sy += insetY;
      sw -= insetX * 2;
      sh -= insetY * 2;
    }
    ctx.drawImage(surfaceImg, sx, sy, Math.min(iw, sw), Math.min(ih, sh), x, y, w, h);
  }

  function sampleAverageColor(img) {
    if (averageColorCache && averageColorCache.has(img)) return averageColorCache.get(img);

    var sample = document.createElement('canvas');
    var size = 24;
    sample.width = size;
    sample.height = size;
    var sctx = sample.getContext('2d', { willReadFrequently: true });
    var color = { r: 170, g: 160, b: 145 };

    try {
      sctx.drawImage(img, 0, 0, size, size);
      var data = sctx.getImageData(0, 0, size, size).data;
      var r = 0, g = 0, b = 0, count = 0;
      for (var i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 16) continue;
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        count++;
      }
      if (count) {
        color = {
          r: Math.round(r / count),
          g: Math.round(g / count),
          b: Math.round(b / count)
        };
      }
    } catch (_) {}

    if (averageColorCache) averageColorCache.set(img, color);
    return color;
  }

  function applyPatternTone(ctx, patternImg, x, y, w, h) {
    if (!patternImg) return;
    var color = sampleAverageColor(patternImg);
    var fill = 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';

    ctx.save();
    ctx.beginPath();
    ctx.rect(x, y, w, h);
    ctx.clip();

    ctx.globalCompositeOperation = 'multiply';
    ctx.globalAlpha = 0.42;
    ctx.fillStyle = fill;
    ctx.fillRect(x, y, w, h);

    ctx.globalCompositeOperation = 'source-atop';
    ctx.globalAlpha = 0.18;
    ctx.fillStyle = fill;
    ctx.fillRect(x, y, w, h);

    ctx.restore();
  }

  function renderCardCanvas(patternImg, fabricImg, opts) {
    opts = opts || {};
    var canvas = document.createElement('canvas');
    canvas.width = CARD_W;
    canvas.height = CARD_H;
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    // 1) Background: white
    ctx.fillStyle = '#f7f5f1';
    ctx.fillRect(0, 0, CARD_W, CARD_H);

    // 2) Pattern body. Collection cards use single-surface mode; the tile branch is kept as a fallback.
    var d = BORDER_DEPTH_PX;
    var bodyX = d, bodyY = d;
    var bodyW = CARD_W - d * 2;
    var bodyH = CARD_H - d * 2;
    if (opts.bodyMode === 'single-surface') {
      if (opts.bodyBlurPx && 'filter' in ctx) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(bodyX, bodyY, bodyW, bodyH);
        ctx.clip();
        ctx.filter = 'blur(' + opts.bodyBlurPx + 'px)';
        drawSingleSurfaceBody(ctx, patternImg, bodyX, bodyY, bodyW, bodyH, opts.surfaceInsetPct || 0);
        ctx.restore();
      } else {
        drawSingleSurfaceBody(ctx, patternImg, bodyX, bodyY, bodyW, bodyH, opts.surfaceInsetPct || 0);
      }
      applyPatternTone(ctx, opts.patternToneImg, bodyX, bodyY, bodyW, bodyH);
    } else {
    var pIw = patternImg.naturalWidth || patternImg.width;
    var pIh = patternImg.naturalHeight || patternImg.height;
    // Tile size: bodyW / PATTERN_TILES_HORIZONTAL → her tile ~30cm gerçek halı alanını temsil eder
    var tileW = Math.round(bodyW / PATTERN_TILES_HORIZONTAL);
    var tileH = Math.round(tileW * (pIh / pIw)); // aspect ratio korunur
    // Pattern image'i tile'a ölçekle (offscreen canvas)
    var ptile = document.createElement('canvas');
    ptile.width = tileW;
    ptile.height = tileH;
    var ptctx = ptile.getContext('2d');
    ptctx.imageSmoothingEnabled = true;
    ptctx.imageSmoothingQuality = 'high';
    ptctx.drawImage(patternImg, 0, 0, tileW, tileH);
    var patternFill = ctx.createPattern(ptile, 'repeat');
    ctx.save();
    ctx.beginPath();
    ctx.rect(bodyX, bodyY, bodyW, bodyH);
    ctx.clip();
    // Tile başlangıcını body'ye hizala (pattern translate)
    ctx.translate(bodyX, bodyY);
    ctx.fillStyle = patternFill;
    ctx.fillRect(0, 0, bodyW, bodyH);
    ctx.restore();
    }

    // 3) Border 4 strip — Top, bottom, left, right (fabric center-crop tile)
    drawFabricBorderStrip(ctx, 0, 0, CARD_W, d, fabricImg);            // Top
    drawFabricBorderStrip(ctx, 0, CARD_H - d, CARD_W, d, fabricImg);    // Bottom
    drawFabricBorderStrip(ctx, 0, 0, d, CARD_H, fabricImg);             // Left
    drawFabricBorderStrip(ctx, CARD_W - d, 0, d, CARD_H, fabricImg);    // Right

    // 4) Subtle perspective shading on border — top highlight, bottom shadow
    ctx.save();
    var topGrad = ctx.createLinearGradient(0, 0, 0, d);
    topGrad.addColorStop(0, 'rgba(255,255,255,0.10)');
    topGrad.addColorStop(0.5, 'rgba(255,255,255,0.02)');
    topGrad.addColorStop(1, 'rgba(0,0,0,0.05)');
    ctx.fillStyle = topGrad;
    ctx.fillRect(0, 0, CARD_W, d);
    var botGrad = ctx.createLinearGradient(0, CARD_H - d, 0, CARD_H);
    botGrad.addColorStop(0, 'rgba(0,0,0,0.05)');
    botGrad.addColorStop(0.5, 'rgba(0,0,0,0.02)');
    botGrad.addColorStop(1, 'rgba(0,0,0,0.10)');
    ctx.fillStyle = botGrad;
    ctx.fillRect(0, CARD_H - d, CARD_W, d);
    ctx.restore();

    // 5) İç kenar dikişi — ÇOK İNCE sürekli çizgi (ürün sayfasıyla aynı stil, opacity 0.26)
    if (opts.innerStitch === true) {
      var stitchInset = Math.max(2, Math.round(d * 0.08));
      ctx.strokeStyle = 'rgba(32, 26, 20, 0.26)';
      ctx.lineWidth = Math.max(1.2, d * 0.025);
      ctx.strokeRect(bodyX - stitchInset + 0.5, bodyY - stitchInset + 0.5, bodyW + stitchInset * 2 - 1, bodyH + stitchInset * 2 - 1);
    }

    return canvas;
  }

  function appendBorderParam(link, borderId) {
    try {
      var href = link.getAttribute('href');
      if (!href) return;
      var sep = href.indexOf('?') === -1 ? '?' : '&';
      // Param zaten varsa override etme
      if (/[?&]b=/.test(href)) return;
      link.setAttribute('href', href + sep + 'b=' + encodeURIComponent(borderId));
    } catch (_) {}
  }

  function processCard(link, config) {
    var handle = parseHandle(link.getAttribute('href') || link.href);
    if (!handle) return;
    var handleMatch = handle.match(/^massimo-(?:carpet-)?([a-z0-9]+)-(\d+)(?:-ozel-olcu)?$/i);
    if (!handleMatch) return;
    var quality = handleMatch[1].toLowerCase();
    var pattern = handleMatch[2];
    var configKey = quality + '-' + pattern;  // örn. "lasis-3812"

    var cardRoot = findCardRoot(link);
    if (!cardRoot || cardRoot.dataset.massimoCardRendered === '1') return;
    var cardImgs = findCardImage(cardRoot);
    if (!cardImgs || !cardImgs.length) return;

    var productCfg = (config.products || {})[configKey];
    // Alias fallback: Shopify quality ↔ Massimo iç kalite kodu (örn barcelona→barceleno)
    if (!productCfg && QUALITY_ALIAS[quality]) {
      var aliasKey = QUALITY_ALIAS[quality] + '-' + pattern;
      productCfg = (config.products || {})[aliasKey];
    }
    // Fallback: handle ile de dene (eski format ihtimaline karşı)
    if (!productCfg) productCfg = (config.products || {})[handle];
    // Shopify handle'i urun kodundan farkli kalmissa config'teki acik handle alanlarini kullan.
    // Barcelona 302 canlida /barcelona-303-ozel-olcu handle'i ile yasadigi icin kart buradan eslesir.
    if (!productCfg) productCfg = findProductConfigByHandle(config, handle);
    if (!productCfg || !pickPreviewBaseImage(productCfg) || !pickRenderPatternImage(productCfg)) {
      console.warn('[massimo-collection-render] config / preview kaynakları yok:', configKey, '(handle:', handle, ')');
      return;
    }
    var canvasFabrics = (config.kartelas && config.kartelas.canvas) || [];
    if (!canvasFabrics.length) {
      console.warn('[massimo-collection-render] kartelas.canvas listesi boş');
      return;
    }
    var border = pickRandomBorder(handle, canvasFabrics);
    if (!border || !border.image) return;

    cardRoot.dataset.massimoCardRendered = '1';

    renderProductPreviewCanvas(productCfg, border)
      .then(function (canvas) {
        var dataUrl = canvas.toDataURL('image/jpeg', 0.86);
        var badgeHost = null;
        // v9: HER img'i (main + hover) replace et — tema iki varyant gösteriyor
        cardImgs.forEach(function (oldImg) {
          var newImg = document.createElement('img');
          newImg.src = dataUrl;
          newImg.setAttribute('loading', 'eager');
          newImg.setAttribute('alt', oldImg.getAttribute('alt') || '');
          newImg.setAttribute('width', String(canvas.width || CARD_W));
          newImg.setAttribute('height', String(canvas.height || CARD_H));
          if (oldImg.className) newImg.className = oldImg.className;
          if (oldImg.style.cssText) newImg.style.cssText = oldImg.style.cssText;
          newImg.setAttribute('data-massimo-card-render', BUILD);
          if (oldImg.parentNode) {
            if (!badgeHost) {
              badgeHost = (oldImg.closest && oldImg.closest('a[href*="/products/"]')) || oldImg.parentNode;
            }
            oldImg.parentNode.replaceChild(newImg, oldImg);
          }
        });
        ensureEuBadge(cardRoot, badgeHost);
        // Bu karttaki tüm aynı handle'a giden linklere bordür ID URL param ekle
        var allLinks = cardRoot.querySelectorAll('a[href*="/products/"]');
        Array.prototype.forEach.call(allLinks, function (lnk) {
          if ((lnk.getAttribute('href') || '').indexOf(handle) > -1) appendBorderParam(lnk, border.id);
        });
      })
      .catch(function (err) {
        console.warn('[massimo-collection-render] render failed:', handle, err.message || err);
        cardRoot.dataset.massimoCardRendered = ''; // retry için flag temizle
      });
  }

  function processAllCards() {
    var links = Array.from(document.querySelectorAll('a[href*="/products/massimo-"]'));
    if (!links.length) return;
    loadConfig().then(function (config) {
      links.forEach(function (l) { processCard(l, config); });
    }).catch(function (err) {
      console.warn('[massimo-collection-render] config yüklenemedi:', err.message || err);
    });
  }

  function isCollectionLike() {
    var path = (window.location.pathname || '').toLowerCase();
    if (/^\/products\//.test(path)) return false;
    return true; // Ana sayfa, kategori, arama — hepsinde çalışsın
  }

  // === Product page: URL param ?b=canvas-XX → o bordür fabric'i seç ===
  function applyBorderParam() {
    var path = (window.location.pathname || '').toLowerCase();
    if (!/^\/products\/massimo-/.test(path)) return;
    var params = new URLSearchParams(window.location.search || '');
    var borderId = params.get('b');
    if (!borderId || !/^canvas-\d+$/i.test(borderId)) return;

    var attempts = 0;
    var maxAttempts = 30; // 30 × 200ms = 6 saniye max bekleme
    var interval = setInterval(function () {
      attempts++;
      var swatchBtn = document.querySelector('button.massimo-oo-swatch[data-kartela-code="' + borderId.toLowerCase() + '"]');
      if (swatchBtn) {
        if (!swatchBtn.classList.contains('is-active')) {
          swatchBtn.click();
        }
        clearInterval(interval);
        // Bordür edge'i de zorla seç (default biye olabilir)
        var bordurBtn = document.querySelector('button.massimo-oo__btn[data-massimo-edge="bordur"]');
        if (bordurBtn && !bordurBtn.classList.contains('is-active')) bordurBtn.click();
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  }

  function init() {
    // Product sayfasında: URL param handler çalışsın
    applyBorderParam();
    // Collection-like sayfalarda: kartları render et
    if (!isCollectionLike()) return;
    processAllCards();
    var debounce;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(processAllCards, 350);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
